import { ready, isLoggedIn } from './utils'

const switcher = (event) => {
	event.preventDefault()

	const currentLang = document.querySelector('html').getAttribute('lang')
    const lang 	   	  = event.target.getAttribute('data-lang');

	location.href = location.pathname.replace(`/${ currentLang }`, `/${ lang }`)
}

const common = {
	initMenu: () => {
		const nav        = document.querySelector('.js-main-nav')
		const menuBtn    = nav.querySelector('.js-navToggle')
        const loginBtn   = document.querySelector('.js-nav-loginbtn')
        const myPagesBtn = document.querySelector('.js-nav-mybtn')

		if (isLoggedIn()) {
			nav.classList.add('bg-smalt-blue')
			nav.classList.add('bg-none')

			loginBtn.style.display = 'none'
			myPagesBtn.style.display = 'block'
		} else {
			nav.classList.remove('bg-smalt-blue')

            loginBtn.style.display = 'block'
			myPagesBtn.style.display = 'none';
		}

		if (menuBtn) {
			menuBtn.addEventListener('click', () => {
				nav.classList.toggle('mobile-menu-open')
			})

			const navDropdownIcons = document.querySelectorAll('nav .dropdown-icon')

			for (let i = 0; i < navDropdownIcons.length; i++) {
				navDropdownIcons[i].addEventListener('click', (e) => {
					e.preventDefault()
					e.stopPropagation()

                    return false
				})
			}

			let prevScrollpos = window.pageYOffset

			window.onscroll = function () {
				const currentScrollPos = window.pageYOffset

				if (currentScrollPos === 0 && nav.classList.contains('colored')) {
					nav.classList.remove('colored')
				}

				if (prevScrollpos > currentScrollPos && !nav.classList.contains('nav-sticky')) {
					nav.classList.add('nav-sticky')
					nav.classList.add('colored')
				} else if (prevScrollpos < currentScrollPos && window.pageYOffset > 100 && nav.classList.contains('nav-sticky')) {
					nav.classList.remove('nav-sticky')
				}

				prevScrollpos = currentScrollPos;
			}
		}
	},
    initSubMenu: () => {
		const subMenuBtn = document.querySelector('.js-expandSubmenu')

		const onClick = (e) => {
			slide({
				e,
				parentSelector: 'ul',
				contentSelector: '.submenu-items',
			})
		}

		if (subMenuBtn) {
			subMenuBtn.addEventListener('click', onClick)
		}
	},
    init: () => ready(() => {
        common.initMenu()
        common.initSubMenu()

		if (location.pathname.indexOf('my-pages') > -1) {
			document.querySelector('.fn-trans-sv').addEventListener('click', switcher)
			document.querySelector('.fn-trans-en').addEventListener('click', switcher)
		}
    })
}

export default common